import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '../../services/alert.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit {

  @Input() id: number | undefined;
  @Input() message: string | undefined;
  @Input() error: boolean = true;
  display = true;

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {}

  onClose() {
    this.display = false;
    if (this.id != undefined) {
      this.alertService.removeAlert(this.id);
    }
  }

}
